import Query from '../utils/Query';
import Model from "../models/Model";

const defaultFields = '*,created_by.*,created_by.avatar.private_hash';

export default class ComponentService {

	static getAll(id) {
		return Query.get('/items/component' + (id ? '?filter[created_by]=' + id + '&fields=' + defaultFields : ''));
	}

	static getByUser(userId) {
		return Query.get('/items/component?fields=' + defaultFields + '&filter[created_by]=' + userId);
	}

	static countByUser(userId) {
		return Query.get('/items/component?filter[created_by]=' + userId + '&meta=filter_count&limit=0');
	}

	static get(id, revisionOffset) {
		return Query.get('/items/component/' + id + (revisionOffset !== undefined ? '/revisions/' + revisionOffset : '') + '?fields=' + defaultFields);
	}

	static getRevisions(id) {
		return Query.get('/items/component/' + id + '/revisions?limit=25&fields=*,activity.action_by.first_name,activity.action_by.last_name,activity.action_by.screen_name,activity.action_by.avatar.private_hash');
	}

	static fork(revisionId) {
		return Query.post('/custom/component/fork/' + revisionId);
	}

	static build(id, password) {
		return Query.post('/custom/component/build/' + id, {
			password
		});
	}

	static buildList(id) {
		return Query.get('/custom/component/build/' + id + '/list');
	}

	static buildStatus(id, executionId) {
		return Query.get('/custom/component/build/' + id + '/status/' + executionId);
	}

	static buildLogs(id, executionId) {
		return Query.get('/custom/component/build/' + id + '/logs/' + executionId);
	}

	static buildLaunch(id, executionId) {
		return Query.get('/custom/component/build/' + id + '/launch/' + executionId);
	}

	static buildApply(id, executionId) {
		return Query.post('/custom/component/build/' + id + '/apply/' + executionId);
	}

	static save(id, data) {

		if (id) {
			return Query.patch('/items/component/' + id, data);
		} else {
			return Query.post('/items/component', data);
		}
	}

	static remove(id) {
		return Query.patch('/items/component/' + id, {
			status: 'deleted'
		});
	}

	static restore(id) {
		return Query.patch('/items/component/' + id, {
			status: 'draft'
		});
	}
}
